module.exports = Object.freeze({
  NONE: 0, // 権限無し
  VIEW: 10, // 閲覧権限
  VIEW_SELF: 20, // 自データの閲覧権限
  EDIT_SELF: 21, // 自データの編集権限
  VIEW_SUBORDINATE: 30, // 部下の閲覧権限
  EDIT_SUBORDINATE: 31, // 部下の編集権限
  VIEW_ALL: 40, // 全体の閲覧権限
  EDIT_ALL: 41, // 全体の編集権限
});
